/**
 * Content registry - allows main.app to receive ContentData from the active experience.
 * Set by the router before main.app loads.
 */
import type { Data } from '@core/content/types';
import type { ExperienceId } from './experiences';

let contentData: Data[] | null = null;
let experienceId: ExperienceId | null = null;

export function setContentData(data: Data[]): void {
  contentData = data;
}

export function getContentData(): Data[] {
  if (!contentData) {
    throw new Error('ContentData not set. Ensure the experience is loaded before main.app initializes.');
  }
  return contentData;
}

export function setExperienceId(id: ExperienceId): void {
  experienceId = id;
}

export function getExperienceId(): ExperienceId {
  if (!experienceId) {
    throw new Error('ExperienceId not set. Ensure the experience is loaded before main.app initializes.');
  }
  return experienceId;
}
